import React from 'react';
import StudentLayout from '../../components/student/StudentLayout'
import instance from '../../axios/instance';
import { useSelector } from 'react-redux';
import { Button, Paper, styled, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow } from '@mui/material';
import { t } from 'i18next';
import Loading from '../../components/Loading';
import Cookies from "js-cookie";
import { Link } from 'react-router-dom';


const Root = styled('div')(({ theme }) => ({
    width: '100%',
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    '& > :not(style) ~ :not(style)': {
        marginTop: theme.spacing(2),
    },
}));

function StudentRecource() {
    const lang = Cookies.get("i18next") || "en";
    const columns = [
        { id: "image", label: t("Photo"), minWidth: 150 },
        { id: "resource type", label: t("resource type"), minWidth: 150 },
        { id: "level", label: t("level"), minWidth: 150 },
        { id: "subject", label: t("subject"), minWidth: 150 },
        { id: "link", label: t("Link Resource"), minWidth: 150 },
        { id: "docs", label: t("Resource documents"), minWidth: 150 },
        { id: "class", label: t("classes"), minWidth: 150 },
        { id: "semester", label: t("semester"), minWidth: 150 },
        { id: "studycurriculums", label: t("studycurriculums"), minWidth: 150 },
        { id: "price", label: t("price"), minWidth: 150 },

    ];

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const { student } = useSelector(state => state.student);
    const [data, setData] = React.useState(null);
    React.useEffect(() => {
        (async () => {
            const res = await instance(`student/getMyResources/${student.id}`);
            console.log(res.data.data);

            setData(res.data.data);
        })();
    }, [student.id]);

    if (data === null) return <Loading />
    else if (!data.length) return <StudentLayout><h1 className='text-center text-2xl text-sky-500 mt-20'>{t("Currently unavailable resources")}</h1></StudentLayout>
    else return (
        <StudentLayout>
            <Root>
                <Paper sx={{ width: "100%", padding: "20px" }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={"center"}
                                        style={{ top: 57, minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableBody>
                                {data
                                    ?.filter((row) => {
                                        return lang === "ar" || lang === "en"
                                            ? row.resource?.resource && row.resource?.resource
                                            : row.resource?.resource && row.resource?.descriptionEnglish;
                                    })
                                    ?.map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" key={row.id + "demj"}>
                                                <TableCell align="center"><img src={row.resource?.image ? `${process.env.REACT_APP_API_KEY}images/${row.resource?.image}` : "/logo.png"} alt={row.resource?.image} width={"100px"} /></TableCell>
                                                <TableCell align="center">{t(row.resource?.resource)}</TableCell>
                                                <TableCell align="center">{lang === "ar" ?row.level?.titleAR:row.level?.titleEN}</TableCell>
                                                <TableCell align="center">{lang === "ar" ?row.subject?.titleAR:row.subject?.titleEN}</TableCell>
                                                {row.resource?.linkResource ? <TableCell align="center">
                                                    <Button
                                                        component={Link}
                                                        to={row.resource?.linkResource}
                                                        target="_blank" // يفتح الرابط في صفحة جديدة
                                                        rel="noopener noreferrer"
                                                    >
                                                        {t("Link Resource")}
                                                    </Button>
                                                </TableCell> : <>
                                                    <TableCell align="center">{t("No link Exam")}</TableCell>
                                                </>}
                                                {row.resource?.docs ? <TableCell align="center">
                                                    <Button
                                                        component={Link}
                                                        to={`${process.env.REACT_APP_API_KEY}images/${row.resource?.docs}`}
                                                        target="_blank" // يفتح الرابط في صفحة جديدة
                                                        rel="noopener noreferrer"
                                                    >
                                                        {t("Resource documents")}
                                                    </Button>
                                                </TableCell> : <>
                                                    <TableCell align="center">{t("No Documents")}</TableCell>
                                                </>}
                                                <TableCell align="center">{lang === "ar" ?row.classId?.titleAR:row.classId?.titleEN}</TableCell>
                                                <TableCell align="center">{t(row.resource?.semester)}</TableCell>
                                                <TableCell align="center">{lang === "ar" ?row.curriculum?.titleAR:row.curriculum?.titleEN}</TableCell>

                                                <TableCell align="center">{row.resource?.price} </TableCell>

                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Root>
        </StudentLayout>
    )
}

export default StudentRecource;